<script setup lang="ts">
interface Props {
  bg?: 'dark' | 'light'
  blurBg?: boolean
  layout?: 'horizontal' | 'vertical'
}

const props = withDefaults(defineProps<Props>(), {
  bg: 'dark',
  blurBg: false,
  layout: 'vertical',
})

const dinamicClasses = computed(() => ({
  'backdrop-blur-xl': props.blurBg,
  [`bg-${props.bg}`]: true,
}))

const dinamicClassesContent = computed(() => ({
  'flex-col': props.layout === 'vertical',
  'items-center': props.layout === 'horizontal',
}))
</script>

<template>
  <div
    class="rounded-xl border-t border-primary-100/10 p-1"
    :class="dinamicClasses"
  >
    <div
      class="flex"
      :class="dinamicClassesContent"
    >
      <div
        v-if="$slots.header"
        class="flex items-center justify-center rounded-md bg-surface-950 relative overflow-hidden"
        :class="layout === 'horizontal' ? 'h-full p-2' : 'p-4'"
      >
        <slot name="header" />
      </div>
      <div class="p-2 w-full">
        <slot />
      </div>
    </div>
  </div>
</template>
